import { useEffect, useCallback } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useFetchApplicationsWithQuestionnaires = () => {
  const { apiGet } = useApi();
  const useApiState = createApiHook([]);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const fetchApplications = useCallback(async () => {
    startLoading();
    const response = await apiGet("/aplicaciones/index_with_questionnaires", "Error al obtener aplicaciones y sus cuestionarios");
    setResponse(response);
    return response?.data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchApplications();
  }, [fetchApplications]);

  return { data, error, loading, refetch: fetchApplications };
};

export default useFetchApplicationsWithQuestionnaires;
